import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCoins,
  faList,
  faSearch,
  faDownload,
  faBell,
} from "@fortawesome/free-solid-svg-icons";

import React, { useContext, useEffect, useState } from "react";
import { getFromLocalStorage } from "../utils/local-storage";
import { StoreContext } from "../../context/store";
import useAnalyticsEventTracker from "../analytics/useAnalyticsEventTracker";
import { useDispatch, useSelector } from "react-redux";
import { notificationsData } from "../../redux/dataSlice";
import { shouldShowSearch } from "../../redux/navigationAction";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
export const UserInfo = React.memo((props) => {
  const { profile } = props;
  const pathname = window.location.pathname;
  const { state, dispatch } = useContext(StoreContext);
  const gaEventTracker = useAnalyticsEventTracker("Navigation");
  const userData = useSelector((state) => state.auth.user);
  const navigate = useNavigate();
  const [user, setUser] = useState(getFromLocalStorage("user"));
  const checkVerify = useSelector(
    (state) => state.data.app_config?.accountConfiguration?.verificationEnabled
  );
  const notifications = useSelector((state) => state.data.notifications);

  useEffect(() => {
    if (userData) {
      setUser(userData || getFromLocalStorage("user"));
    }
  }, [userData]);

  useEffect(() => {
    if (user) {
      if (notifications?.length === 0 || notifications === null)
        dispatchRedux(notificationsData());
    }
  }, [user]);

  const dispatchRedux = useDispatch();
  const notShowSearch = dispatchRedux(shouldShowSearch(pathname));

  // const showBalance = excludedPaths.every((path) => !urlPath.includes(path));
  const showSearchBar = () => {
    // setSearching(true)
    dispatch({ type: "SET", key: "searching", payload: true });
    // searchInputRef.current.focus()
    gaEventTracker("Clicked on Search");
  };
  return (
    <>
      {user && (
        <div
          className="col-md-6  d-flex  right justify-content-end align-items-center w-change2 gap-2 ipad-show"
          style={{ marginLeft: "auto" }}
        >
          <div>
            <Link
              to={{ pathname: "/deposit" }}
              className={
                "deposit-button size-font-user-action deposit-button-header"
              }
            >
              <span className="">
                <span className=" ">
                  <FontAwesomeIcon icon={faDownload} />
                </span>
                &nbsp; Deposit
              </span>
            </Link>
          </div>

          {/* {showBalance && (
            <div>
              <div
                className={
                  "deposit-button size-font-user-action d-flex align-items-center"
                }
                style={{ marginRight: "12px" }}
              >
                <span className="text-warning">
                  <span className=" ">
                    <FontAwesomeIcon
                      icon={faCoins}
                      className={"text-warning"}
                    />
                  </span>
                  &nbsp;
                  KSH {formatNumber(user?.balance) || 0.0}
                </span>
              </div>
            </div>
          )} */}
          <div className={"mybets-remove-on-mobile"}>
            <Link
              to={{ pathname: "/mybets" }}
              className={"deposit-button size-font-user-action"}
            >
              <span className={"text-success"}>
                <span className=" ">
                  {" "}
                  <FontAwesomeIcon icon={faList} />
                </span>
                &nbsp; MY BETS
              </span>
            </Link>
          </div>
          {!profile && notShowSearch && (
            <div className="d-flex align-items-baseline mx-2">
              <div
                className={` align-items-center  ${
                  state?.searching
                    ? !pathname.includes("casino") &&
                      !pathname.includes("crashgames")
                      ? "d-none"
                      : "d-flex"
                    : "d-flex"
                }`}
              >
                <div
                  className="cursor-pointer link_color"
                  title="Search"
                  onClick={() => {
                    showSearchBar();
                    gaEventTracker("Visit Search");
                  }}
                >
                  <span className="border-radius-search p-2 align-items-center  justify-content-center d-flex">
                    <FontAwesomeIcon icon={faSearch} />{" "}
                  </span>
                  <span></span>
                </div>
              </div>
            </div>
          )}
          <div
            className="position-relative notifications-alert"
            onClick={() => navigate("/notifications")}
          >
            {/* <FontAwesomeIcon icon={faBell} className="text-xl  border-radius-search" /> */}

            <NotificationsNoneIcon  sx={{ fontSize: 30 }} />

            {notifications?.notifications?.filter((n) => n.read_status === 0)
              .length > 0 && (
              <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger notifications-badge">
                {notifications.notifications.filter((n) => n.read_status === 0)
                  .length > 99
                  ? "99+"
                  : notifications.notifications.filter(
                      (n) => n.read_status === 0
                    ).length}
              </span>
            )}
          </div>
        </div>
      )}
      <>
        {!user && (
          <div
            className="col-sm-2 mobile-profile1 align-items-center gap-3 ipad-show"
            style={{ marginLeft: "auto" }}
          >
            {pathname !== "/signup" && checkVerify && checkVerify !== "0" && (
              <div className="remove-verify">
                <Link
                  className="cg  login-color login-size btn bg-success text-light"
                  to={"/verify"}
                  title="Verify Account"
                  onClick={() => gaEventTracker("Verify")}
                >
                  <span className="register-label text-light">Verify</span>
                </Link>
              </div>
            )}
            {pathname !== "/signup" && (
              <div className="">
                <Link
                  className="cg  login-color login-size btn bg-warning text-light"
                  to={"/signup"}
                  title="Join now"
                  onClick={() => gaEventTracker("Register")}
                >
                  <span className="button-text-color-on-yellow text-weight-md">
                    Register
                  </span>
                </Link>
              </div>
            )}

            {pathname !== "/signup" && (
              <Link
                to={"/login"}
                className="cg  login-color login-size btn"
                type="submit"
              >
                <span>Login</span>
              </Link>
            )}
            {pathname !== "/signup" && (
              <div className="d-flex align-items-baseline">
                <div
                  className={` align-items-center  ${
                    state?.searching ? "d-none" : "d-flex"
                  }`}
                  style={{ marginLeft: "5px" }}
                >
                  <div
                    className="cursor-pointer link-color"
                    title="Search"
                    onClick={() => {
                      showSearchBar();
                      gaEventTracker("Visit Search");
                    }}
                  >
                    <span className="border-radius-search p-2  justify-content-center d-flex">
                      <FontAwesomeIcon icon={faSearch} />{" "}
                    </span>
                    <span></span>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </>
    </>
  );
});
